module.exports = __webpack_public_path__ + "app/images/teams-icon-color.5a6d40fd.svg";